(() => {
  const template = document.getElementById('cg-appcart-reassurance');
  if (!template || !window.MutationObserver) return;

  const drawerSelector = '.qsc2-drawer-wrapper';
  const summarySelector = '.qsc2-drawer-footer__summary';
  let signature = '';
  let cachedCart = null;
  let requestId = 0;
  let scheduled = false;

  const showCart = (summary, cart) => {
    const message = summary.querySelector('.qsc2-drawer-footer__cart-message');
    if (!message) return;
    let block = summary.querySelector('[data-cg-appcart]');
    const applicable = cart && cart.currency === 'EUR' &&
      Number.isFinite(cart.total_price) && Number.isFinite(cart.total_weight) &&
      cart.total_weight <= 23000 && cart.items?.some(item => item.requires_shipping);
    if (!applicable) {
      message.hidden = false;
      if (block) block.remove();
      return;
    }
    if (!block) {
      block = template.content.firstElementChild.cloneNode(true);
      message.before(block);
    }
    block.querySelector('[data-cg-paid]').hidden = cart.total_price >= 6000;
    block.querySelector('[data-cg-free]').hidden = cart.total_price < 6000;
    message.hidden = true;
  };

  const update = async () => {
    scheduled = false;
    const summary = document.querySelector(summarySelector);
    const price = summary?.querySelector('.qsc2-drawer-footer__summary-subtotal-price');
    if (!summary || !price) return;
    const drawer = summary.closest(drawerSelector);
    if (!drawer) return;
    const nextSignature = JSON.stringify([
      price.textContent,
      [...drawer.querySelectorAll('a[href*="/products/"]')].map(link => link.getAttribute('href')),
      [...drawer.querySelectorAll('input[aria-label="Quantity input"]')].map(input => input.value)
    ]);
    if (nextSignature === signature) {
      if (cachedCart) showCart(summary, cachedCart);
      return;
    }
    signature = nextSignature;
    cachedCart = null;
    const currentRequest = ++requestId;
    try {
      const response = await fetch(template.dataset.cartUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Cart information unavailable');
      const cart = await response.json();
      if (currentRequest !== requestId) return;
      cachedCart = cart;
      const currentSummary = document.querySelector(summarySelector);
      if (currentSummary) showCart(currentSummary, cart);
    } catch {
      if (currentRequest !== requestId) return;
      const currentSummary = document.querySelector(summarySelector);
      if (currentSummary) showCart(currentSummary, null);
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  const observer = new MutationObserver(mutations => {
    const relevant = mutations.some(mutation => {
      const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target?.closest('[data-cg-appcart]')) return false;
      if (target?.closest(drawerSelector)) return true;
      return [...mutation.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches(drawerSelector) || node.querySelector(drawerSelector)));
    });
    if (relevant) schedule();
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  schedule();
})();
